import { report } from './monitor';

/**
 * Service Worker: precache del app shell (offline total) y servidor de /__asset/*.
 * Una versión nueva de la app se instala en segundo plano y queda "waiting"; solo se activa
 * (y se recarga) cuando el tótem entra en reposo, nunca frente a un cliente.
 */
let registration: ServiceWorkerRegistration | null = null;
let reloading = false;

export async function registerSW() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  try {
    registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) location.reload();
    });
    // Buscar app nueva cada 5 min (solo pide sw.js; se aplica en reposo)
    setInterval(() => registration?.update().catch(() => {}), 5 * 60_000);
  } catch (e) {
    report(e, { op: 'sw-register' });
  }
}

export function hasAppUpdate(): boolean {
  return !!registration?.waiting && !!navigator.serviceWorker.controller;
}

/** Activa la versión en espera; el controllerchange recarga la página */
export function applyAppUpdate() {
  const w = registration?.waiting;
  if (!w) return false;
  reloading = true;
  w.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

/** Espera (máx. ms) a que la página quede controlada por el SW: así las imágenes salen de /__asset/ */
export function waitForController(ms: number): Promise<void> {
  if (!('serviceWorker' in navigator) || navigator.serviceWorker.controller || import.meta.env.DEV) return Promise.resolve();
  return new Promise((resolve) => {
    const t = setTimeout(resolve, ms);
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => {
        clearTimeout(t);
        resolve();
      },
      { once: true },
    );
  });
}

export async function requestPersistence() {
  try {
    if (navigator.storage?.persist && !(await navigator.storage.persisted())) await navigator.storage.persist();
  } catch {
    /* sin soporte */
  }
}
